var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 49,
    viewBox: "0 0 85 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6402 15.906L21.9375 41.7774C21.646 42.651 20.5975 43.0107 19.8217 42.5015L6.06472 33.4993C4.32041 32.3595 4.43795 29.7761 6.2857 28.7997L30.6402 15.9014V15.906Z",
    fill: "url(#paint0_linear_3775_55436)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.008 30.9349H8.77371C7.66882 30.9349 6.85073 31.9486 7.09052 33.0231L8.79722 35.3355L5.21926 32.925C3.44674 31.7664 2.68507 29.5661 3.35741 27.5666L12.7842 1.59769C13.1039 0.644682 14.0019 0 15.0128 0H83.4489C84.8547 0 85.5317 1.70981 84.5068 2.66282L72.7968 14.3883C72.021 15.1077 71.7765 16.2289 72.1855 17.2006L75.442 28.8046C75.8651 29.8184 75.1129 30.9302 74.0127 30.9302L74.008 30.9349Z",
    fill: "url(#paint1_linear_3775_55436)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M21.8627 49C33.9371 49 43.7253 47.3267 43.7253 45.2627C43.7253 43.1986 33.9371 41.5254 21.8627 41.5254C9.78825 41.5254 0 43.1986 0 45.2627C0 47.3267 9.78825 49 21.8627 49Z",
    fill: "url(#paint2_radial_3775_55436)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3775_55436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3697 19L16.0497 10.6H19.7817C20.9097 10.6 21.7777 10.844 22.3857 11.332C23.0017 11.82 23.3097 12.504 23.3097 13.384C23.3097 14.088 23.1337 14.708 22.7817 15.244C22.4377 15.78 21.9457 16.196 21.3057 16.492C20.6737 16.788 19.9257 16.936 19.0617 16.936H16.3497L17.8617 15.7L17.2017 19H14.3697ZM17.7897 16.036L16.7937 14.752H19.2057C19.5977 14.752 19.9017 14.656 20.1177 14.464C20.3337 14.264 20.4417 13.988 20.4417 13.636C20.4417 13.332 20.3457 13.116 20.1537 12.988C19.9697 12.852 19.7137 12.784 19.3857 12.784H17.1897L18.7017 11.464L17.7897 16.036ZM23.1705 19L24.8505 10.6H28.6185C29.7305 10.6 30.5905 10.844 31.1985 11.332C31.8065 11.812 32.1105 12.488 32.1105 13.36C32.1105 14.064 31.9345 14.68 31.5825 15.208C31.2385 15.736 30.7465 16.148 30.1065 16.444C29.4745 16.74 28.7265 16.888 27.8625 16.888H25.1505L26.6625 15.7L26.0025 19H23.1705ZM28.3065 19L26.5785 15.94H29.4945L31.2465 19H28.3065ZM26.5905 16.036L25.5945 14.752H28.0065C28.3985 14.752 28.7025 14.656 28.9185 14.464C29.1345 14.264 29.2425 13.988 29.2425 13.636C29.2425 13.332 29.1465 13.116 28.9545 12.988C28.7705 12.852 28.5145 12.784 28.1865 12.784H25.9905L27.5025 11.464L26.5905 16.036ZM36.8399 19.192C35.9679 19.192 35.2119 19.032 34.5719 18.712C33.9399 18.392 33.4479 17.952 33.0959 17.392C32.7519 16.824 32.5799 16.172 32.5799 15.436C32.5799 14.692 32.7079 14.016 32.9639 13.408C33.2279 12.792 33.5959 12.26 34.0679 11.812C34.5399 11.364 35.0999 11.02 35.7479 10.78C36.3959 10.532 37.1039 10.408 37.8719 10.408C38.7439 10.408 39.4959 10.568 40.1279 10.888C40.7679 11.208 41.2599 11.652 41.6039 12.22C41.9559 12.78 42.1319 13.428 42.1319 14.164C42.1319 14.908 41.9999 15.588 41.7359 16.204C41.4799 16.812 41.1159 17.34 40.6439 17.788C40.1719 18.236 39.6119 18.584 38.9639 18.832C38.3159 19.072 37.6079 19.192 36.8399 19.192ZM37.0799 16.9C37.4319 16.9 37.7399 16.832 38.0039 16.696C38.2759 16.56 38.5079 16.372 38.6999 16.132C38.8919 15.892 39.0359 15.62 39.1319 15.316C39.2279 15.004 39.2759 14.676 39.2759 14.332C39.2759 14.004 39.2079 13.72 39.0719 13.48C38.9439 13.232 38.7559 13.04 38.5079 12.904C38.2679 12.768 37.9759 12.7 37.6319 12.7C37.2879 12.7 36.9799 12.768 36.7079 12.904C36.4359 13.04 36.2039 13.228 36.0119 13.468C35.8199 13.708 35.6759 13.984 35.5799 14.296C35.4839 14.6 35.4359 14.924 35.4359 15.268C35.4359 15.588 35.4999 15.872 35.6279 16.12C35.7639 16.368 35.9519 16.56 36.1919 16.696C36.4399 16.832 36.7359 16.9 37.0799 16.9ZM42.2838 19L43.9638 10.6H46.2678L48.5118 16.084H47.2878L51.6078 10.6H54.0198L52.3638 19H49.7838L50.6598 14.488L51.0678 14.464L48.1638 18.244H46.9158L45.2838 14.452L45.7638 14.488L44.8638 19H42.2838ZM58.461 19.192C57.589 19.192 56.833 19.032 56.193 18.712C55.561 18.392 55.069 17.952 54.717 17.392C54.373 16.824 54.201 16.172 54.201 15.436C54.201 14.692 54.329 14.016 54.585 13.408C54.849 12.792 55.217 12.26 55.689 11.812C56.161 11.364 56.721 11.02 57.369 10.78C58.017 10.532 58.725 10.408 59.493 10.408C60.365 10.408 61.117 10.568 61.749 10.888C62.389 11.208 62.881 11.652 63.225 12.22C63.577 12.78 63.753 13.428 63.753 14.164C63.753 14.908 63.621 15.588 63.357 16.204C63.101 16.812 62.737 17.34 62.265 17.788C61.793 18.236 61.233 18.584 60.585 18.832C59.937 19.072 59.229 19.192 58.461 19.192ZM58.701 16.9C59.053 16.9 59.361 16.832 59.625 16.696C59.897 16.56 60.129 16.372 60.321 16.132C60.513 15.892 60.657 15.62 60.753 15.316C60.849 15.004 60.897 14.676 60.897 14.332C60.897 14.004 60.829 13.72 60.693 13.48C60.565 13.232 60.377 13.04 60.129 12.904C59.889 12.768 59.597 12.7 59.253 12.7C58.909 12.7 58.601 12.768 58.329 12.904C58.057 13.04 57.825 13.228 57.633 13.468C57.441 13.708 57.297 13.984 57.201 14.296C57.105 14.6 57.057 14.924 57.057 15.268C57.057 15.588 57.121 15.872 57.249 16.12C57.385 16.368 57.573 16.56 57.813 16.696C58.061 16.832 58.357 16.9 58.701 16.9ZM64.6729 15.784L65.1649 10.6H68.4049L66.8329 15.784H64.6729ZM65.2849 19.12C64.8449 19.12 64.4849 18.992 64.2049 18.736C63.9249 18.48 63.7849 18.168 63.7849 17.8C63.7849 17.352 63.9449 16.984 64.2649 16.696C64.5849 16.408 64.9809 16.264 65.4529 16.264C65.9009 16.264 66.2609 16.388 66.5329 16.636C66.8129 16.884 66.9529 17.192 66.9529 17.56C66.9529 17.848 66.8769 18.112 66.7249 18.352C66.5809 18.584 66.3849 18.772 66.1369 18.916C65.8889 19.052 65.6049 19.12 65.2849 19.12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3775_55436",
    x: 12.3701,
    y: 8.4082,
    width: 62.0352,
    height: 16.7842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3775_55436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3775_55436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3775_55436",
    x1: 17.7342,
    y1: 46.4304,
    x2: 17.7342,
    y2: 30.5375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA192D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#690E19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3775_55436",
    x1: 42.0567,
    y1: -2.38774,
    x2: 42.0567,
    y2: 40.9134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D50402"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3775_55436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8627 45.2684) scale(20.6073 3.89038)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CCCDCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E7E8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F8F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoIconRed);
export default __webpack_public_path__ + "static/media/PromoIconRed.e86f26cbfa13ed17c2cb4fd2475d440f.svg";
export { ForwardRef as ReactComponent };